exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reports-tab-forms-automate{margin-top:20px;display:flex}.reports-tab-forms-automate .reports-tab-automate-frequency-selector{min-width:122px;width:16%;margin-bottom:0}.reports-tab-forms-automate .reports-tab-automate-date-filter-selector{width:36%;min-width:300px;display:inline-flex}.reports-tab-forms-automate .date-picker-type-datetime-picker{width:50%;margin-right:0}.reports-tab-forms-automate .date-picker-type-datetime-picker:first-of-type{margin-right:5px}.reports-tab-forms-automate .submit-btn-spacer{margin-top:22px}.reports-tab-forms-automate .reports-tab-forms-automate-submit{margin-left:auto}.reports-tab-forms-automate .reports-tab-forms-automate-submit a{margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTabForms/AutomateReportAndDelivery/automateReportAndDelivery.less
// module id = 1652
// module chunks = 0